import { cn } from '../../lib/utils';

/**
 * Badge component (shadcn-style) with design system variants
 * Variants: default (primary), secondary, destructive, outline, inverted, success, warning, danger, neutral
 */
export function Badge({ children, variant = 'neutral', className, ...props }) {
  const variantClasses = {
    default: 'bg-primary text-primary-foreground shadow hover:bg-primary/90',
    secondary: 'bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80',
    destructive: 'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90',
    outline: 'border border-input bg-transparent text-[var(--ds-text-primary)] hover:bg-accent hover:text-accent-foreground',
    inverted: 'border border-[#3778E2] bg-[#141821] text-[#3778E2]',
    success: cn(
      'text-[var(--ds-status-success)]',
      'bg-[var(--ds-status-success-bg)]'
    ),
    warning: cn(
      'text-[var(--ds-status-warning)]',
      'bg-[var(--ds-status-warning-bg)]'
    ),
    danger: cn(
      'text-[var(--ds-status-danger)]',
      'bg-[var(--ds-status-danger-bg)]'
    ),
    neutral: cn(
      'text-[var(--ds-text-secondary)]',
      'bg-[var(--ds-control-field-bg)]'
    ),
  };

  return (
    <span
      className={cn(
        'inline-flex items-center',
        'px-2.5 py-1.5',
        'text-micro font-semibold',
        variant === 'default' || variant === 'secondary' || variant === 'destructive' || variant === 'outline' || variant === 'inverted'
          ? 'rounded-md'
          : 'rounded-[var(--ds-radius-pill)]',
        variantClasses[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}

